/* Gray Crane Studios — behaviour for the custom sections.
   Rotators for hero + quotes (arrows/dots force-advance and reset the timer)
   and the to-scale print size visualiser. */

(function () {
  function initRotator(root, opts) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var slides = root.querySelectorAll(opts.slide);
    if (slides.length < 2) {
      if (slides[0]) slides[0].classList.add('on');
      return;
    }
    var dots = opts.dots ? root.querySelectorAll(opts.dots + ' button') : [];
    var credit = opts.credit ? root.querySelector(opts.credit) : null;
    var i = opts.random ? Math.floor(Math.random() * slides.length) : 0;
    var timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === i)); });
      if (credit) credit.textContent = slides[i].dataset.credit || '';
    }
    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, opts.interval);
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); restart(); });
    });
    root.querySelectorAll('.gcs-arrow').forEach(function (a) {
      a.addEventListener('click', function () { show(i + (+a.dataset.dir)); restart(); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    show(i); restart();
  }

  function initViz(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var cap = root.querySelector('[data-viz-size]');
    function select(label) {
      if (cap) cap.textContent = label;
      root.querySelectorAll('.gcs-ghost').forEach(function (g) {
        g.classList.toggle('sel', g.dataset.label === label);
      });
    }
    var form = document.querySelector('form[data-type="add-to-cart-form"]') ||
               document.querySelector('product-info form');
    document.addEventListener('change', function (e) {
      var info = e.target && e.target.closest && e.target.closest('product-info, variant-selects');
      if (!info) return;
      var checked = document.querySelectorAll(
        'variant-selects input[type="radio"]:checked, variant-selects select');
      checked.forEach(function (el) {
        var v = el.value || '';
        if (!/\d/.test(v)) return;
        document.querySelectorAll('[data-gcs-selsize]').forEach(function (n) { n.textContent = v; });
        /* sizes contain inch marks ("), so match by comparing data-label —
           never by building a CSS selector from the value */
        var match = false;
        root.querySelectorAll('.gcs-ghost').forEach(function (g) {
          if (g.dataset.label === v) match = true;
        });
        if (match) select(v);
      });
    });
    var sel = root.querySelector('.gcs-ghost.sel');
    if (!sel && root.querySelector('.gcs-ghost')) {
      var cur = document.querySelector('variant-selects input[type="radio"]:checked');
      var want = cur ? cur.value : '';
      var hit = null;
      root.querySelectorAll('.gcs-ghost').forEach(function (g) {
        if (g.dataset.label === want) hit = g;
      });
      select((hit || root.querySelector('.gcs-ghost')).dataset.label);
    }
  }

  function initGallery(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var big = root.querySelector('[data-gcs-big]');
    root.querySelectorAll('.gcs-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        big.src = t.dataset.src;
        if (t.dataset.zoom) big.dataset.zoomSrc = t.dataset.zoom;
        root.querySelectorAll('.gcs-thumb').forEach(function (x) {
          x.setAttribute('aria-selected', String(x === t));
        });
      });
    });
    initZoom(root, big);
  }

  /* click-to-enlarge lightbox: opens the high-res file fitted to the screen,
     a second click goes to actual size with drag/scroll panning. */
  function initZoom(root, big) {
    var ov = document.querySelector('.gcs-zoom');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'gcs-zoom';
      ov.hidden = true;
      ov.innerHTML =
        '<button type="button" class="gcs-zoom__close" aria-label="Close">&times;</button>' +
        '<div class="gcs-zoom__stage"><img alt=""></div>' +
        '<span class="gcs-zoom__hint"></span>';
      document.body.appendChild(ov);
      var st = ov.querySelector('.gcs-zoom__stage');
      var im = ov.querySelector('img');
      var hint = ov.querySelector('.gcs-zoom__hint');

      ov.close = function () {
        ov.hidden = true;
        ov.classList.remove('zoomed');
        document.documentElement.style.overflow = '';
      };
      ov.show = function (src, alt) {
        im.src = src; im.alt = alt || '';
        ov.hidden = false;
        ov.classList.remove('zoomed');
        hint.textContent = 'Click the photo to zoom in';
        document.documentElement.style.overflow = 'hidden';
      };

      im.addEventListener('click', function (e) {
        var on = ov.classList.toggle('zoomed');
        hint.textContent = on ? 'Click again to zoom out' : 'Click the photo to zoom in';
        if (!on) return;
        var r = im.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width;
        var fy = (e.clientY - r.top) / r.height;
        /* setTimeout, not rAF - rAF never fires in a hidden tab */
        setTimeout(function () {
          st.scrollLeft = fx * st.scrollWidth - st.clientWidth / 2;
          st.scrollTop = fy * st.scrollHeight - st.clientHeight / 2;
        }, 0);
      });

      /* drag to pan while zoomed */
      var down = false, sx = 0, sy = 0, sl = 0, stp = 0, moved = false;
      st.addEventListener('mousedown', function (e) {
        if (!ov.classList.contains('zoomed')) return;
        down = true; moved = false;
        sx = e.clientX; sy = e.clientY; sl = st.scrollLeft; stp = st.scrollTop;
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        if (Math.abs(e.clientX - sx) > 3 || Math.abs(e.clientY - sy) > 3) moved = true;
        st.scrollLeft = sl - (e.clientX - sx);
        st.scrollTop = stp - (e.clientY - sy);
      });
      window.addEventListener('mouseup', function () { down = false; });
      /* a drag shouldn't also count as the zoom-out click */
      im.addEventListener('click', function (e) {
        if (moved) { e.stopImmediatePropagation(); moved = false; }
      }, true);

      ov.querySelector('.gcs-zoom__close').addEventListener('click', ov.close);
      st.addEventListener('click', function (e) { if (e.target === st) ov.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !ov.hidden) ov.close();
      });
    }

    function open() { ov.show(big.dataset.zoomSrc || big.src, big.alt); }
    big.addEventListener('click', open);
    var btn = root.querySelector('[data-gcs-zoom-open]');
    if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); open(); });
  }


  // Bird of the Month slideshow: arrows, thumbnails, arrow keys, and swipe.
  function initSlides(root) {
    if (!root || root.dataset.gcsSlidesReady) return;
    root.dataset.gcsSlidesReady = '1';
    var slides = root.querySelectorAll('[data-gcs-slide]');
    var thumbs = root.querySelectorAll('[data-gcs-slide-thumb]');
    var count = root.querySelector('[data-gcs-slide-count]');
    var stage = root.querySelector('.gcs-slides__stage');
    var n = slides.length, i = 0;
    if (n < 2) return;
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, j) { s.hidden = j !== i; });
      thumbs.forEach(function (t, j) {
        if (j === i) {
          t.setAttribute('aria-current', 'true');
          var strip = t.parentNode;
          strip.scrollLeft = t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
        } else t.removeAttribute('aria-current');
      });
      if (count) count.textContent = (i + 1) + ' / ' + n;
    }
    var prev = root.querySelector('[data-gcs-slide-prev]');
    var next = root.querySelector('[data-gcs-slide-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(i - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(i + 1); e.preventDefault(); }
    });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-gcs-slides]').forEach(initSlides);
    initRotator(document.querySelector('.gcs-hero'),
      { slide: '.gcs-hero__media img', credit: '.gcs-hero__credit', interval: 7000 });
    document.querySelectorAll('.gcs-quotes').forEach(function (q) {
      initRotator(q, { slide: '.gcs-quotes__slide', dots: '.gcs-quotes__dots',
                       interval: 8000, random: true });
    });
    initViz(document.querySelector('.gcs-viz'));
    initGallery(document.querySelector('[data-gcs-gal]'));
  }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
  window.addEventListener('pageshow', boot);
  document.addEventListener('gcs:swap', boot);
})();

/* ---------------- instant format switching ----------------
   Formats are separate products, so a click is a real navigation. Instead,
   fetch the sibling page and swap #MainContent in place — Dawn's custom
   elements re-initialize on insertion, scroll position is kept, and any
   failure falls back to a normal page load. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.gcs-format');
    if (!a || a.getAttribute('aria-current') === 'true') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    var url = a.href;
    fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.getElementById('MainContent');
      var cur = document.getElementById('MainContent');
      if (!next || !cur) throw new Error('no main');
      var y = window.scrollY;
      cur.replaceWith(next);
      document.title = doc.title;
      window.history.pushState({ gcsFmt: 1 }, '', url);
      window.scrollTo(0, y);
      document.dispatchEvent(new Event('gcs:swap'));
    }).catch(function () {
      window.location.href = url;
    });
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.gcsFmt) window.location.reload();
  });
})();

/* ---------------- concept-style collection filters (client-side) ----------------
   Facets derive from each card's data-gcs-* attributes: Gary's own tags grouped
   by the concept taxonomy, orientation from image aspect ratio. */
(function () {
  var SUBJECTS = [
    ['Bison', ['bison', 'buffalo']],
    ['Moose', ['moose']], ['Elk', ['elk']],
    ['Bears', ['bear', 'bears', 'grizzly bear', 'grizzly bears', 'grizzly cubs', 'bear cubs', 'cubs', 'black bear']],
    ['Wolves', ['wolf', 'wolves', 'wovles', 'gray wolf', 'timberwolf']],
    ['Foxes', ['fox', 'red fox']], ['Coyotes', ['coyote', 'sage coyote']],
    ['Cougars', ['cougar', 'mountain lion']],
    ['Bighorn & goats', ['ram', 'rams', 'mountain goat']],
    ['Pronghorn', ['pronghorn', 'antelope']],
    ['Ravens', ['raven']], ['Magpies', ['magpie']],
    ['Jays', ['bluejay', 'jay', 'stellar jay', 'scrub jay']],
    ['Eagles', ['bald eagle', 'eagle']], ['Owls', ['owl', 'great gray owl']],
    ['Hawks & kestrels', ['hawk', 'kestrel', 'american kestrel', 'birds of prey']],
    ['Cranes', ['crane', 'cranes', 'sandhill cranes']],
    ['Herons & shorebirds', ['heron', 'great blue heron', 'shorebirds']],
    ['Ducks & geese', ['duck', 'ducks', 'mallard', 'mallards', 'goose', 'cinnamon teal']],
    ['Grouse', ['grouse', 'sage grouse']],
    ['Songbirds', ['junco', 'tanager', 'western tanager', 'meadowlark', 'western meadowlark', 'blackbird']],
    ['Birds (all)', ['bird', 'birds']],
    ['Horses', ['horse', 'horses']],
    ['Trees & aspens', ['trees', 'aspens']],
    ['Barns', ['barn', 'winter barn', 'mormon barn']],
    ['Scenic & landscape', ['scenic']]
  ];
  var PLACES = [
    ['Grand Teton', ['grand teton national park', 'tetons', 'snake river', 'crane flats']],
    ['Yellowstone', ['yellowstone', 'yellowstone national park', 'lamar valley']],
    ['Glacier NP', ['glacier national park', 'saint marys', "saint mary's lake"]],
    ['Southern Utah', ['southern utah', 'bryce canyon', 'redrock', 'utah', 'deadhorse point']],
    ['Uintas & Wasatch', ['uintas', 'albion basin', 'alpine', 'wasatch front']],
    ['Alaska', ['alaska']]
  ];

  function facetsOf(li) {
    var tags = (li.dataset.gcsTags || '').split('|');
    var has = function (keys) {
      return keys.some(function (k) { return tags.indexOf(k) > -1; });
    };
    var ar = parseFloat(li.dataset.gcsAr || '1.4');
    return {
      subject: SUBJECTS.filter(function (g) { return has(g[1]); }).map(function (g) { return g[0]; }),
      place: PLACES.filter(function (g) { return has(g[1]); }).map(function (g) { return g[0]; }),
      orient: ar > 1.9 ? 'Panorama' : (ar >= 1 ? 'Landscape' : 'Portrait'),
      treat: tags.indexOf('sepia') > -1 ? ['Sepia'] : []
    };
  }

  function build() {
    var shell = document.querySelector('[data-gcs-filters]');
    var grid = document.getElementById('product-grid');
    if (!shell || !grid || shell.dataset.init) return;
    var items = [].slice.call(grid.querySelectorAll('.grid__item[data-gcs-tags]'));
    if (items.length < 4) return;
    shell.dataset.init = '1';
    var facets = items.map(facetsOf);

    function counts(get) {
      var c = {};
      facets.forEach(function (f) {
        [].concat(get(f)).forEach(function (v) { if (v) c[v] = (c[v] || 0) + 1; });
      });
      return c;
    }
    var groups = [
      ['Subject', 'subject', counts(function (f) { return f.subject; })],
      ['Place', 'place', counts(function (f) { return f.place; })],
      ['Orientation', 'orient', counts(function (f) { return f.orient; })],
      ['Treatment', 'treat', counts(function (f) { return f.treat; })]
    ];
    var rail = shell.querySelector('[data-gcs-rail]');
    var html = '';
    groups.forEach(function (g) {
      var rows = Object.keys(g[2]).filter(function (v) {
        return g[2][v] > 0 && g[2][v] < items.length;
      }).sort(function (a, b) { return g[2][b] - g[2][a]; });
      if (!rows.length) return;
      html += '<div class="gcs-fgrp"><h4>' + g[0] + '</h4>' + rows.map(function (v) {
        return '<label><input type="checkbox" data-g="' + g[1] + '" data-v="' + v + '">' +
               v + '<span>' + g[2][v] + '</span></label>';
      }).join('') + '</div>';
    });
    if (!html) { return; }
    rail.innerHTML = html;
    shell.hidden = false;
    shell.querySelector('[data-gcs-total]').textContent = items.length;
    shell.querySelector('[data-gcs-shown]').textContent = items.length;

    function apply() {
      var on = {};
      rail.querySelectorAll('input:checked').forEach(function (i) {
        (on[i.dataset.g] = on[i.dataset.g] || []).push(i.dataset.v);
      });
      var shown = 0;
      items.forEach(function (li, idx) {
        var f = facets[idx], ok = true;
        Object.keys(on).forEach(function (g) {
          var vals = on[g];
          var have = g === 'orient' ? [f.orient] : f[g];
          if (!vals.some(function (v) { return have.indexOf(v) > -1; })) ok = false;
        });
        li.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      shell.querySelector('[data-gcs-shown]').textContent = shown;
      shell.querySelector('[data-gcs-clear]').hidden = !Object.keys(on).length;
    }
    rail.addEventListener('change', apply);
    shell.querySelector('[data-gcs-clear]').addEventListener('click', function () {
      rail.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; });
      apply();
    });
    shell.querySelector('[data-gcs-toggle]').addEventListener('click', function () {
      shell.classList.toggle('open');
    });
  }
  document.addEventListener('DOMContentLoaded', build);
  if (document.readyState !== 'loading') build();
  window.addEventListener('pageshow', build);
})();
